export default __webpack_public_path__ + "static/media/unknown.8553828c.svg";